import 'reflect-metadata'

import { Type } from 'class-transformer'
import { IsNotEmpty, IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator'
import { SaveTranslation } from './translation'

export class SaveLaboratoryTypes {
  @IsNumber()
  @IsOptional()
  id: number | undefined

  @IsString()
  @IsNotEmpty()
  key: string | undefined

  @IsOptional()
  @Type(() => SaveTranslation)
  @ValidateNested()
  translations: SaveTranslation[] | undefined
}
